"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactRedux = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Utils = require("./utils");
var components_1 = require("./components");
require("./index.scss");
var component = function () {
    var _a, _b, _c;
    var dispatchers = Utils.mapDispatchers(ReactRedux.useDispatch());
    var currentUser = ReactRedux.useSelector(function (state) { return state.auth.current.user; });
    var userSettings = ReactRedux.useSelector(function (state) { return state.user.userSettings; });
    var _d = React.useState((_b = (_a = userSettings.consents) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : {}), localUserConsents = _d[0], setLocalUserConsents = _d[1];
    var resolvedCurrentUser = currentUser.fold(undefined, function (user) { return user; });
    var resolvedSettingsUser = userSettings.user.fold(undefined, function (user) { return user; });
    React.useEffect(function () { return void dispatchers.fetchRegions(); }, []);
    React.useEffect(function () {
        if (!Number.isInteger(resolvedSettingsUser === null || resolvedSettingsUser === void 0 ? void 0 : resolvedSettingsUser.id))
            return;
        dispatchers.fetchUserConsents(resolvedSettingsUser.id);
    }, [userSettings.user]);
    React.useEffect(function () { var _a, _b; return setLocalUserConsents((_b = (_a = userSettings.consents) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : {}); }, [userSettings.consents]);
    var updateUserConsents = function () {
        if (!Number.isInteger(resolvedSettingsUser === null || resolvedSettingsUser === void 0 ? void 0 : resolvedSettingsUser.id))
            return;
        dispatchers.updateUserConsents(resolvedSettingsUser.id, localUserConsents);
    };
    var isAdminTabVisible = userSettings.mode === 'ADMIN';
    var isPasswordTabVisible = userSettings.mode === 'USER' &&
        !(resolvedSettingsUser === null || resolvedSettingsUser === void 0 ? void 0 : resolvedSettingsUser.federated) &&
        (resolvedCurrentUser === null || resolvedCurrentUser === void 0 ? void 0 : resolvedCurrentUser.id) === (resolvedSettingsUser === null || resolvedSettingsUser === void 0 ? void 0 : resolvedSettingsUser.id);
    var isUserConsentsTabVisible = Number.isInteger(resolvedSettingsUser === null || resolvedSettingsUser === void 0 ? void 0 : resolvedSettingsUser.id) &&
        (userSettings.mode === 'ADMIN' ||
            (resolvedCurrentUser === null || resolvedCurrentUser === void 0 ? void 0 : resolvedCurrentUser.id) === (resolvedSettingsUser === null || resolvedSettingsUser === void 0 ? void 0 : resolvedSettingsUser.id));
    var tabHeaders = [
        {
            key: 'profile-tab',
            text: (0, translation_1.getLocalization)('components/userSettingsGeneralModal/profileTab')
        },
        {
            key: 'avatar-tab',
            text: (0, translation_1.getLocalization)('components/userSettingsGeneralModal/avatarTab')
        },
        isPasswordTabVisible
            ? {
                key: 'password-tab',
                text: (0, translation_1.getLocalization)('components/userSettingsGeneralModal/password')
            }
            : null,
        isAdminTabVisible
            ? {
                key: 'admin-tab',
                text: (0, translation_1.getLocalization)('components/userSettingsGeneralModal/adminTabs')
            }
            : null,
        isUserConsentsTabVisible
            ? {
                key: 'user-consents-tab',
                text: (0, translation_1.getLocalization)('components/userSettingsGeneralModal/userConsentsTab')
            }
            : null
    ]
        .map(function (tab) { return tab && React.createElement("div", { key: tab.key }, tab.text); })
        .filter(Boolean);
    var tabContents = [
        React.createElement(components_1.UserSettingsTabContent, { key: "profile-content" }),
        React.createElement(components_1.AvatarTabContent, { key: "avatar-content" }),
        isPasswordTabVisible ? React.createElement(components_1.PasswordTabContent, { key: "password-content" }) : null,
        isAdminTabVisible ? (React.createElement(components_1.AdminToolsTabContent, { key: "admin-tools-content" })) : null,
        isUserConsentsTabVisible ? (React.createElement(components_1.UserConsentsTabContent, { key: "user-consents-content", consents: localUserConsents, onChange: setLocalUserConsents })) : null
    ].filter(Boolean);
    var activeTabKey = (_c = tabHeaders[userSettings.currentTabIndex]) === null || _c === void 0 ? void 0 : _c.key;
    return (React.createElement(sok_ui_1.Modal, { className: "user-settings-modal", isOpen: userSettings.isOpen },
        React.createElement(sok_ui_1.Header, { onClose: dispatchers.close(userSettings.onCloseActions) }, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/userSettingsHeader')),
        React.createElement(sok_ui_1.Container, null,
            React.createElement(components_1.RequestStatusBoxes, { authenticationCode: userSettings.sendAuthenticationCodeStatus, company: userSettings.changeCompanyStatus, consents: userSettings.consents.status, email: userSettings.changeEmailStatus, passwordReset: userSettings.resetPasswordStatus, profile: userSettings.updateProfileStatus, removal: userSettings.removeUserStatus }),
            React.createElement(sok_ui_1.Tabs, { activeIndex: userSettings.currentTabIndex, onClick: dispatchers.changeTab }, __spreadArray(__spreadArray([], tabHeaders, true), tabContents, true))),
        React.createElement(sok_ui_1.Footer, null,
            (activeTabKey === 'profile-tab' || activeTabKey === 'avatar-tab') && (React.createElement(sok_ui_1.Button, { color: "base-green", text: (0, translation_1.getLocalization)('components/userSettingsGeneralModal/buttons/save'), icon: React.createElement(sok_ui_1.Icon, { className: "fa-check-circle" }), disabled: userSettings.updateProfileStatus.isBusy, onClick: function () { return dispatchers.saveProfile(); } })),
            userSettings.mode === 'ADMIN' && activeTabKey === 'admin-tab' && (React.createElement(sok_ui_1.Button, { color: "base-green", text: (0, translation_1.getLocalization)('components/userSettingsGeneralModal/buttons/save'), icon: React.createElement(sok_ui_1.Icon, { className: "fa-check-circle" }), disabled: (!userSettings.company && !userSettings.newEmail) ||
                    userSettings.updateProfileStatus.isBusy, onClick: function () {
                    return userSettings.user.fold(undefined, function (_a) {
                        var uuid = _a.uuid;
                        return dispatchers.save(uuid, userSettings.company);
                    });
                } })),
            activeTabKey === 'user-consents-tab' && (React.createElement(sok_ui_1.Button, { color: "base-green", text: (0, translation_1.getLocalization)('components/userSettingsGeneralModal/buttons/save'), icon: React.createElement(sok_ui_1.Icon, { className: "fa-check-circle" }), disabled: userSettings.consents.status.isBusy, onClick: updateUserConsents })),
            React.createElement(sok_ui_1.Button, { color: "dark-gray", text: (0, translation_1.getLocalization)('components/userSettingsGeneralModal/buttons/close'), onClick: dispatchers.close(userSettings.onCloseActions) }))));
};
exports.default = component;
